import React from 'react';
import s from './TransactionTable.module.sass'
export const TransactionTable = () => {
    return (
        <div className={s.tableContainer}>
            <table className={s.transactionTable}>
                <thead>
                <tr>
                    <th>Transaction</th>
                                    <th>Type</th>
                <th>Status</th>
                    <th>Amount (EUR)</th>
                                    <th>Fill (EUR)</th>
                <th>Fee (EUR)</th>
                    <th>Trigger (BNB)</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>ETH</td>
                    <td>Withdrawal</td>
                    <td className={s.statusProcessing}>In process</td>
                    <td>1,581,943.72</td>
                    <td>1,581,943.72</td>
                    <td>-</td>
                    <td>-</td>
                </tr>
                <tr>
                    <td>USD</td>
                    <td>Deposit</td>
                    <td className={s.statusSuccess}>Success</td>
                    <td>49,000</td>
                    <td>49,000</td>
                    <td>-</td>
                    <td>-</td>
                </tr>
                </tbody>
            </table>
        </div>
    );
};
